import {PageHeading} from '@/components/ui/page-atoms/PageAtoms'
import {useTranslation} from '@/translations/i18n'
import {Helmet} from 'react-helmet'
import {StyledMailerWrapper, StyledMailerSubtitle, StyledMailerViewport} from './style'
import {MailerForm} from '@/features/mailer/components/mailer-form/MailerForm'
import {MailerHistoryTab} from '@/features/mailer/components/mailer-history-tab/MailerHistoryTab'
import {MailerTabs} from '@/features/mailer/components/mailer-tabs/MailerTabs'
import {MailerBatchDetailsModal} from '@/features/mailer/components/mailer-batch-details-modal/MailerBatchDetailsModal'
import {useMailHistorySearchParams} from '@/features/mailer/hooks/useMailHistorySearchParams'
import {IS_PRODUCTION_SEND_ENABLED} from '@/features/mailer/constants'

export const Mailer = () => {
    const {t} = useTranslation()
    const {searchParams, setSearchParams} = useMailHistorySearchParams()

    return (
        <StyledMailerWrapper>
            <Helmet title={t('mailer:title')} />
            <PageHeading direction="column" align="flex-start" gap={1}>
                <h2>{t('mailer:title')}</h2>
                {!IS_PRODUCTION_SEND_ENABLED && (
                    <StyledMailerSubtitle>{t('mailer:page_subtitle_test_mode')}</StyledMailerSubtitle>
                )}
            </PageHeading>
            <MailerTabs
                view={searchParams.view}
                onChange={view => setSearchParams({view, page: 1, search: undefined})}
            />

            <StyledMailerViewport>
                {/* Both views stay mounted so drafts, attachment state and table scroll
                    survive tab switches; the inactive one is just hidden. */}
                <div hidden={searchParams.view !== 'compose'}>
                    <MailerForm />
                </div>
                <div hidden={searchParams.view !== 'history'}>
                    <MailerHistoryTab />
                </div>
            </StyledMailerViewport>

            {searchParams.batch && (
                <MailerBatchDetailsModal
                    batchId={searchParams.batch}
                    page={searchParams.detailPage}
                    limit={20}
                    status={searchParams.detailStatus}
                    onClose={() => setSearchParams({batch: undefined, detailPage: undefined, detailStatus: undefined})}
                    onChangePage={page => setSearchParams({detailPage: page})}
                    onChangeStatus={status => setSearchParams({detailStatus: status, detailPage: 1})}
                />
            )}
        </StyledMailerWrapper>
    )
}
